import React from 'react';

import Typography from 'components/typography/typography';

import { DUOPersonRegisterURL } from 'constants/signup-flow-constants';

const PersonRegisterInstructions: React.FC = () => {
  return (
    <div className="w-full flex flex-col">
      <Typography as="p" variant="body-medium" className="text-gray600">
        {`Het Personenregister Kinderopvang (PRK) is een systeem waarin iedereen
        ingeschreven staat die werkt of woont op een adres waar kinderen worden
        opgevangen. Iedereen die werkt in de kinderopvang moet zich inschrijven
        in het PRK.`}
        <br />
        <br />
        {`Voor de inschrijving in het PRK is een Verklaring Omtrent het Gedrag
        (VOG) nodig. Hiermee bewijzen de ingeschrevenen dat hun gedrag in het
        verleden geen bezwaar is voor het uitoefenen van hun taak of beroep.
        Opvanglocaties kunnen dat via jouw inschrijving in het PRK controleren.
        Deze inschrijving is van belang bij mogelijke controle van de GGD’s.`}
        <br />
        <br />
        Om je registratie te uploaden, maak je een schermafbeelding van je
        registratie op de site van het personenregister. Zorg dat op de
        schermafbeelding duidelijk je naam en VOG-kenmerk zichtbaar zijn.
        <br />
        <br />
        <b>Nog niet ingeschreven?</b>
        <br />
        Je kunt je inschrijven tegen betaling{' '}
        <b>
          <a href={DUOPersonRegisterURL} target="_blank" rel="noreferrer">
            via de website van DUO.
          </a>{' '}
        </b>
        <br />
        <br />
        Je moet dan later wel nog je PRK inschrijving uploaden via mijn Tadaah.
        Anders kan je niet aan de slag als freelancer in de kinderopvang.
      </Typography>
      <div className="w-full flex justify-center my-2">
        <img
          src={`${window.STATIC_URL}assets/signupflow/instructions-login-duo.png`}
          alt="instructions for PKR registration"
          className="w-[80%]"
        />
      </div>
    </div>
  );
};

export default PersonRegisterInstructions;
